/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { Checkbox, Input } from 'semantic-ui-react';
import { Tooltip } from '../../../../components/widgets/tooltip';

import { t } from '../../../../locales/i18n';
import { BHConfig } from '../../../../types/business-hours';
import styled from 'styled-components';

import { sizes } from '../../../../themes/sizes';

const Container = styled.section``;

const FieldWrapper = styled.section`
  display: grid;
  grid-template-columns: 230px 50px 1fr;
  align-items: center;
  justify-items: start;
  gap: ${sizes.margins.large};
`;
const ControlWrapper = styled.section`
  display: grid;
  grid-template-columns: 75px 40px 75px 40px;
  justify-items: start;
  align-items: center;
`;
const Label = styled.section``;

interface ConfigProps {
  bhConfig: BHConfig;
  onChange: (fieldName: string, value: any) => void;
}

export function Config(props: ConfigProps) {
  const { bhConfig } = props;
  return (
    <Container>
      <FieldWrapper>
        <Label>{t('bh.queueMinutesShift')}</Label>
        <Tooltip tipKey="queueMinutesShift" />
        <ControlWrapper>
          <Input
            value={bhConfig.openQueueMinutesShift}
            onChange={(event: any, { value }) => props.onChange('openQueueMinutesShift', value)}
            type="number"
            step="5"
          />
          <Tooltip tipKey="openShift" />
          <Input
            value={bhConfig.closeQueueMinutesShift}
            onChange={(event: any, { value }) => props.onChange('closeQueueMinutesShift', value)}
            type="number"
            step="5"
          />
          <Tooltip tipKey="closeShift" />
        </ControlWrapper>
      </FieldWrapper>
      <FieldWrapper>
        <Label>{t('bh.onlineCheckinMinutesShift')}</Label>
        <Tooltip tipKey="onlineCheckinMinutesShift" />
        <ControlWrapper>
          <Input
            value={bhConfig.openOnlineCheckinMinutesShift}
            onChange={(event: any, { value }) => props.onChange('openOnlineCheckinMinutesShift', value)}
            type="number"
            step="5"
          />
          <Tooltip tipKey="openShift" />
          <Input
            value={bhConfig.closeOnlineCheckinMinutesShift}
            onChange={(event: any, { value }) => props.onChange('closeOnlineCheckinMinutesShift', value)}
            type="number"
            step="5"
          />
          <Tooltip tipKey="closeShift" />
        </ControlWrapper>
      </FieldWrapper>
      <FieldWrapper>
        <Label>{t('bh.doNotCloseOnBreak')}</Label>
        <Tooltip tipKey="doNotCloseOnBreak" />
        <ControlWrapper>
          <Checkbox
            toggle
            checked={bhConfig.doNotCloseOnBreak}
            onChange={(event: any, { checked }) => props.onChange('doNotCloseOnBreak', checked)}
          />
        </ControlWrapper>
      </FieldWrapper>
      <FieldWrapper>
        <Label>{t('bh.resetQueueOnFirstDayOpen')}</Label>
        <Tooltip tipKey="resetQueueOnFirstDayOpen" />
        <ControlWrapper>
          <Checkbox
            toggle
            checked={bhConfig.resetQueueOnFirstDayOpen}
            onChange={(event: any, { checked }) => props.onChange('resetQueueOnFirstDayOpen', checked)}
          />
        </ControlWrapper>
      </FieldWrapper>
    </Container>
  );
}
